<div class="toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast" [attr.data-type]="toast.type">
      <div class="toast-content">
        <div class="toast-icon">
          @if (toast.type === 'error') {
            <img src="/assets/icons/toast-error.svg" alt="Error" width="40" height="40" />
          }
          @if (toast.type === 'success') {
            <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="#16A34A"/>
              <path d="M14 24L20 30L34 16" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
          @if (toast.type === 'info') {
            <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="#3B82F6"/>
              <path d="M24 32V24M24 16H24.02" stroke="white" stroke-width="3" stroke-linecap="round"/>
            </svg>
          }
          @if (toast.type === 'warning') {
            <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="#F59E0B"/>
              <path d="M24 16V24M24 32H24.02" stroke="white" stroke-width="3" stroke-linecap="round"/>
            </svg>
          }
        </div>
        <div class="toast-message">
          {{ toast.message | transloco }}
        </div>
        <div class="toast-close">
          <img src="/assets/icons/toast-close.svg" alt="Close" width="40" height="40" (click)="onClose(toast.id)" style="cursor: pointer;" />
        </div>
      </div>
    </div>
  }
</div>
